<template>
  <div :style="'background-color:' + pageColor">
    <ProjectHeader>
      <img src="./BA-hero@2x.jpg" alt="Brentwood Academy">
    </ProjectHeader>
    <Summary :backgroundColor="summaryColor">
      <div slot="left">
        <h2 class="subtitle">Client</h2>
        <div class="content">
          <p>Brentwood Academy</p>
          <br>
        </div>

        <h2 class="subtitle">My Role</h2>
        <div class="content">
          <p>User Experience</p>
          <p>UI Design</p>
        </div>

      </div>
      <div slot="right">
        <h2 class="subtitle">Summary</h2>
        <div class="content">
          <p>
            Brentwood Academy wanted to transition from their templated platform for schools and universities to a
            custom designed website for their 50th anniversary.
          </p>
          <p>
            They were looking for a design and user experience that would separate them from other schools in the
            area.
          </p>
        </div>
      </div>
    </Summary>

    <div class="section">
      <div class="container">
        <img src="./BA-macbook@2x.png" alt="">
      </div>
    </div>

    <ProjectGoals :color="primaryColor">
      <p slot="goal1">Generate admission leads.</p>
      <p slot="goal2">Become a resource for current families.</p>
      <p slot="goal3">Differentiate themselves from other private schools.</p>
    </ProjectGoals>

    <OffsetGallery accentColor="has-accent-light-slate">
      <div slot="col1">
        <img src="./Screen-L@2x.png" alt="">
      </div>
      <div slot="col2">
        <img src="./Screen-R@2x.png" alt="">
      </div>
    </OffsetGallery>
    <div class="section-spacer"></div>

    <SimpleSection title="Sitemaps" :titleColor="primaryColor">
      The previous website had an information overload problem so it was important to create groupings for the main pages. We also moved the less visited pages to the footer navigation.
    </SimpleSection>
    <div class="container">
      <img src="./BA-Sitemap-V2.png" alt="">
    </div>
    <div class="section-spacer"></div>

    <SimpleSection title="Wireframes" :titleColor="primaryColor">
      We needed to highlight key enrollment and industry statistics throughout the site. Expandable content sections were also used to keep the page scannable, but would allow the user to dig deeper into the content that interested them.
    </SimpleSection>
    <div class="section no-side-padding">
      <img src="./ba-wireframes@2x.png" alt="">
    </div>
    <div class="section-spacer"></div>

    <SimpleSection title="Design" :titleColor="primaryColor">
      The client had a specific vision in mind for the look and feel of the site. We were able to take that vision to the next level and created a site that looks high end but maintained approachability.
    </SimpleSection>
    <OffsetGallery class="has-accent-center has-accent-light-slate">
      <div slot="col1">
        <img src="./Screen-L@2x-design.png" alt="">
      </div>
      <div slot="col2">
        <img src="./Screen-R@2x-design.png" alt="">
      </div>
    </OffsetGallery>
    <div class="section-spacer"></div>

    <SimpleSection title="Ui Kit" :titleColor="primaryColor">
      We included a Ui Kit to ensure consistency for our development team and for use in future digital products.
    </SimpleSection>
    <OffsetGallery>
      <div slot="col1">
        <img src="./UI-1.png" alt="">
        <img src="./UI-2.png" alt="">
      </div>
      <div slot="col2">
        <img src="./UI-3.png" alt="">
      </div>
    </OffsetGallery>
    <div class="section no-side-padding">
      <img src="./ba-bot-row@2x.png" alt="">
    </div>
    <router-link to="/food-for-the-hungry">
      <BigButton backgroundColor="#809696" subtitle="Next Project" title="Food for the Hungry"></BigButton>
    </router-link>
  </div>
</template>

<script>
  import Summary from '@/components/Summary'
  import ProjectHeader from '@/components/ProjectHeader'
  import ProjectGoals from '@/components/ProjectGoals'
  import BigButton from '@/components/BigAssButton'
  import OffsetGallery from '@/components/OffsetGallery'
  import SimpleSection from '@/components/SimpleSection'

  export default {
    components: {Summary, ProjectHeader, ProjectGoals, BigButton, OffsetGallery, SimpleSection},
    data() {
      return {
        primaryColor: '#103C6B',
        summaryColor: '#616C78',
        pageColor: '#EBECED',
        offsetGallery1: [
          './Screen-L@2x.png',
        ]
      }
    }
  }
</script>

<style scoped lang="scss">

</style>